import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import RootLayout from './layout.tsx';
// import * as Sentry from '@sentry/react';
// Sentry.init({
//   dsn: 'https://4a035449c2930e2ceacd49669fe552df@o4508344190107648.ingest.de.sentry.io/4508344216453200',
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RootLayout>
    <App />
  </RootLayout>
);
